import { clsx } from "clsx";
import type { MaterialSymbol } from "material-symbols/index.d.ts";
import type { Attributes, CSSProperties, FC } from "react";
import { cloneElement, type ReactElement } from "react";
import { typeOf } from "react-is";

import { useAriaAttributes } from "../../hooks/useAriaAttributes.ts";
import { SymbolIcon } from "./SymbolIcon.tsx";

interface IconProps {
  icon?: ReactElement | MaterialSymbol;
  className?: string;
  style?: CSSProperties;
}

// TODO: Add path to load a SVG image. Also maybe support SVG as Element?
export const Icon: FC<IconProps> = (props) => {
  const ariaAttrs = useAriaAttributes(props);

  if (props.icon == null) return null;

  // typeOf test the existence of object.$$typeof and return something only if it's a known type.
  if (typeOf(props.icon)) {
    // ReactNode
    const newProps = {
      ...ariaAttrs,
      ...(props.icon as ReactElement).props,
      style: { ...props.style, ...(props.icon as ReactElement).props.style },
      className: clsx(props.className, (props.icon as ReactElement).props.className),
    } satisfies Partial<unknown> & Attributes;

    const element = cloneElement(props.icon as ReactElement, newProps);

    return element;
  }

  if (typeof props.icon === "string") {
    return <SymbolIcon icon={props.icon} className={props.className} style={props.style} {...ariaAttrs} />;
  }

  return null;
};
